const subApps = [
  {
    module: "vendor",
    defaultRegister: true,
    devEntry: "//localhost:6004", // 调试路径
    //devEntry: "https://boe.51qqt.com/vendor-static/", //  已编译好路径
    depEntry: "/vendor-static/",
    routerBase: "/vendor",
    data: [],
  },
  {
    module: "system",
    defaultRegister: true,
    devEntry: "//localhost:6005", // 调试路径
    // devEntry: "https://boe.51qqt.com/system-static/", //  已编译好路径
    depEntry: "/system-static/",
    routerBase: "/system",
    data: [],
  },
  {
    module: "rfx",
    defaultRegister: true,
    devEntry: "//localhost:6003", // 调试路径
    // devEntry: "https://boe.51qqt.com/rfx-static/", //  已编译好路径
    depEntry: "/rfx-static/",
    routerBase: "/rfx",
    data: [],
  },
  {
    module: "deliveryplan", //交货计划
    defaultRegister: false,
    devEntry: "//localhost:6002", // 调试路径
    // devEntry: "https://boe.51qqt.com/other-static/", //  已编译好路径
    depEntry: "/deliveryplan-static/",
    routerBase: "/other",
    data: [],
  },
  {
    module: "allup",
    defaultRegister: false,
    devEntry: "//localhost:6009", // 调试路径
    depEntry: "/allup-static/",
    routerBase: "/allup",
    data: [],
  },
  {
    module: "scmpls",
    defaultRegister: false,
    devEntry: "//localhost:6006", // 调试路径
    depEntry: "/scmpls-static/",
    routerBase: "/scmpls",
    data: [],
  },
  {
    module: "performance",
    defaultRegister: false,
    devEntry: "//localhost:6008", // 调试路径
    // devEntry: "https://boe.51qqt.com/performance-static/", //  已编译好路径
    depEntry: "/performance-static/",
    routerBase: "/performance",
    data: [],
  },
  {
    module: "invoicePackingList",
    defaultRegister: false,
    devEntry: "//localhost:4303", // 调试路径
    // devEntry: "https://boe.51qqt.com/performance-static/", //  已编译好路径
    depEntry: "/invoice-packing-list-static/",
    routerBase: "/invoicePackingList",
    data: [],
  },
  {
    module: "equipmentIntegration",
    defaultRegister: false,
    devEntry: "//localhost:6010", // 调试路径
    depEntry: "/equipment-static/",
    routerBase: "/equipmentIntegration",
    data: [],
  },
];

export default subApps;

